import { Box, Skeleton } from '@mui/material';
import {
  skeletonContainerStyles,
  skeletonHeaderStyles,
  skeletonContentStyles,
  skeletonTextContainerStyles,
  skeletonChipContainerStyles,
} from './styles';

export const LoadingSkeleton = () => (
  <Box>
    {[...Array(3)].map((_, index) => (
      <Box key={index} sx={skeletonContainerStyles}>
        <Box sx={skeletonHeaderStyles}>
          <Box sx={skeletonContentStyles}>
            <Box sx={skeletonTextContainerStyles}>
              <Skeleton variant="text" height={28} width="60%" sx={{ mb: 0.5 }} />
              <Skeleton variant="text" height={16} width="30%" />
            </Box>
            <Box sx={skeletonChipContainerStyles}>
              <Skeleton variant="rounded" height={24} width={80} />
              <Skeleton variant="rounded" height={24} width={120} />
            </Box>
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);
